export default "__VITE_ASSET__Ce3s$97b__"